import "antd/dist/antd.less";
import "./App.less";
import VeggyShop from "./components/shop";

function App() {
  return (
    <div className="main">
      <VeggyShop />
    </div>
  );
}

export default App;
